
module dg.objects {

    export class ObjectDisplayerController implements ng.IController {

        public exclude: Array<string>;
        public include: Array<string>;

        private initialized: boolean = false;

        public filteredProps: Array<string>;

        public properties: ng.IPromise<dg.restfulApi.DomainObjectPropertiesMetadata>;
        public value: dg.domain.IDomainObject;

        private handlers: ((v: dg.domain.IDomainObject) => void)[] = [];

        $onInit = () => {
            //this.properties = this.value.dgMeta.properties;

            //if (this.include) {
            //    this.filteredProps = this.include;
            //}
            //else {
            //    let propsArray = Object.keys(this.properties).map(propName => this.properties[propName]);
            //    this.filteredProps = propsArray.sort((p1, p2) => p1.order > p2.order ? 1 : -1).map(p => p.id);

            //    if (this.exclude) {
            //        this.filteredProps = this.filteredProps.filter(p => this.exclude.indexOf(p) === -1);
            //    }
            //}
        }

        private initialize = () => {
            if (this.include) {
                this.filteredProps = this.include;
            }
            else {
                let propsArray = Object.keys(this.properties).map(propName => this.properties[propName]).filter(p => p !== null);
                this.filteredProps = propsArray.sort((p1, p2) => p1.order > p2.order ? 1 : -1).map(p => p.id);

                if (this.exclude) {
                    this.filteredProps = this.filteredProps.filter(p => this.exclude.indexOf(p) === -1);
                }
            }

            this.initialized = true;
        }

        $onChanges(changes) {
            if (changes.value.currentValue) {
                this.properties = this.value.dgMeta.properties;
                if (!this.initialized) {
                    this.initialize();
                }
                this.valueChanged();

            }
        }

        public OnValueChanged = (handler: (v: dg.domain.IDomainObject) => void) => {
            this.handlers.push(handler);

            if (this.value) {
                handler(this.value);
            }
        }

        private valueChanged = () => {
            for (let handler of this.handlers) {
                handler(this.value);
            }
        }
    }

    angular.module('dg.objects').component('objectDisplayer', {
        bindings: {
            value: '<',
            exclude: '<',
            include: '<',
        },
        transclude: true,
        controller: ObjectDisplayerController,
        templateUrl: '/digmo/src/objects/object-displayer.html'
    });
}